var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgE2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_637",
    "data-name": "Group 637",
    transform: "translate(0.121)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    transform: "translate(-0.122)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 57,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 56,
    height: 56,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "university_4_",
    "data-name": "university (4)",
    transform: "translate(2.334 2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_75",
    "data-name": "Rectangle 75",
    width: 47.84,
    height: 29.987,
    transform: "translate(2.353 20.232)",
    fill: "#e1e6e9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_76",
    "data-name": "Rectangle 76",
    width: 2.854,
    height: 4.948,
    transform: "translate(45.348 25.11)",
    fill: "#2d93ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_239",
    "data-name": "Path 239",
    d: "M368.812,209.873v-4.948h2.854Z",
    transform: "translate(-323.464 -179.815)",
    fill: "#27a2db"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_77",
    "data-name": "Rectangle 77",
    width: 2.854,
    height: 4.948,
    transform: "translate(45.348 32.855)",
    fill: "#2d93ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_240",
    "data-name": "Path 240",
    d: "M368.812,272.864v-4.948h2.854Z",
    transform: "translate(-323.464 -235.061)",
    fill: "#27a2db"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_78",
    "data-name": "Rectangle 78",
    width: 2.854,
    height: 4.948,
    transform: "translate(45.348 40.602)",
    fill: "#2d93ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_241",
    "data-name": "Path 241",
    d: "M368.812,335.855v-4.948h2.854Z",
    transform: "translate(-323.464 -290.306)",
    fill: "#27a2db"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_79",
    "data-name": "Rectangle 79",
    width: 2.854,
    height: 4.948,
    transform: "translate(40.647 25.11)",
    fill: "#2d93ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_242",
    "data-name": "Path 242",
    d: "M330.6,209.873v-4.948h2.854Z",
    transform: "translate(-289.947 -179.815)",
    fill: "#27a2db"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_80",
    "data-name": "Rectangle 80",
    width: 2.854,
    height: 4.948,
    transform: "translate(40.647 32.855)",
    fill: "#2d93ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_243",
    "data-name": "Path 243",
    d: "M330.6,272.864v-4.948h2.854Z",
    transform: "translate(-289.947 -235.061)",
    fill: "#27a2db"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_81",
    "data-name": "Rectangle 81",
    width: 2.854,
    height: 4.948,
    transform: "translate(40.647 40.602)",
    fill: "#2d93ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_244",
    "data-name": "Path 244",
    d: "M330.6,335.855v-4.948h2.854Z",
    transform: "translate(-289.947 -290.306)",
    fill: "#27a2db"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_82",
    "data-name": "Rectangle 82",
    width: 2.854,
    height: 4.948,
    transform: "translate(35.952 25.11)",
    fill: "#2d93ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_245",
    "data-name": "Path 245",
    d: "M292.38,209.873v-4.948h2.854Z",
    transform: "translate(-256.43 -179.815)",
    fill: "#27a2db"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_83",
    "data-name": "Rectangle 83",
    width: 2.854,
    height: 4.948,
    transform: "translate(35.952 32.855)",
    fill: "#2d93ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_246",
    "data-name": "Path 246",
    d: "M292.38,272.864v-4.948h2.854Z",
    transform: "translate(-256.43 -235.061)",
    fill: "#27a2db"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_84",
    "data-name": "Rectangle 84",
    width: 2.854,
    height: 4.948,
    transform: "translate(35.952 40.602)",
    fill: "#2d93ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_247",
    "data-name": "Path 247",
    d: "M292.38,335.855v-4.948h2.854Z",
    transform: "translate(-256.43 -290.306)",
    fill: "#27a2db"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_248",
    "data-name": "Path 248",
    d: "M167.2,56.578v32.7H152.254V44.439H167.2Z",
    transform: "translate(-133.533 -39.062)",
    fill: "#d5d6db"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_85",
    "data-name": "Rectangle 85",
    width: 52.462,
    height: 2.07,
    transform: "translate(0 50.218)",
    fill: "#3a556a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_86",
    "data-name": "Rectangle 86",
    width: 6.243,
    height: 9.599,
    transform: "translate(23.071 40.618)",
    fill: "#fcd462"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_87",
    "data-name": "Rectangle 87",
    width: 2.854,
    height: 4.948,
    transform: "translate(13.963 25.11)",
    fill: "#2d93ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_249",
    "data-name": "Path 249",
    d: "M113.562,209.873v-4.948h2.854Z",
    transform: "translate(-99.599 -179.815)",
    fill: "#27a2db"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_88",
    "data-name": "Rectangle 88",
    width: 2.854,
    height: 4.948,
    transform: "translate(13.963 32.855)",
    fill: "#2d93ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_250",
    "data-name": "Path 250",
    d: "M113.562,272.864v-4.948h2.854Z",
    transform: "translate(-99.599 -235.061)",
    fill: "#27a2db"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_89",
    "data-name": "Rectangle 89",
    width: 2.854,
    height: 4.948,
    transform: "translate(13.963 40.602)",
    fill: "#2d93ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_251",
    "data-name": "Path 251",
    d: "M113.562,335.855v-4.948h2.854Z",
    transform: "translate(-99.599 -290.306)",
    fill: "#27a2db"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_90",
    "data-name": "Rectangle 90",
    width: 2.854,
    height: 4.948,
    transform: "translate(9.264 25.11)",
    fill: "#2d93ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_252",
    "data-name": "Path 252",
    d: "M75.347,209.873v-4.948H78.2Z",
    transform: "translate(-66.083 -179.815)",
    fill: "#27a2db"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_91",
    "data-name": "Rectangle 91",
    width: 2.854,
    height: 4.948,
    transform: "translate(9.264 32.855)",
    fill: "#2d93ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_253",
    "data-name": "Path 253",
    d: "M75.347,272.864v-4.948H78.2Z",
    transform: "translate(-66.083 -235.061)",
    fill: "#27a2db"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_92",
    "data-name": "Rectangle 92",
    width: 2.854,
    height: 4.948,
    transform: "translate(9.264 40.602)",
    fill: "#2d93ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_254",
    "data-name": "Path 254",
    d: "M75.347,335.855v-4.948H78.2Z",
    transform: "translate(-66.083 -290.306)",
    fill: "#27a2db"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_93",
    "data-name": "Rectangle 93",
    width: 2.854,
    height: 4.948,
    transform: "translate(4.566 25.11)",
    fill: "#2d93ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_255",
    "data-name": "Path 255",
    d: "M37.131,209.873v-4.948h2.854Z",
    transform: "translate(-32.565 -179.815)",
    fill: "#27a2db"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_94",
    "data-name": "Rectangle 94",
    width: 2.854,
    height: 4.948,
    transform: "translate(4.566 32.855)",
    fill: "#2d93ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_256",
    "data-name": "Path 256",
    d: "M37.131,272.864v-4.948h2.854Z",
    transform: "translate(-32.565 -235.061)",
    fill: "#27a2db"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_95",
    "data-name": "Rectangle 95",
    width: 2.854,
    height: 4.948,
    transform: "translate(4.566 40.602)",
    fill: "#2d93ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_257",
    "data-name": "Path 257",
    d: "M37.131,335.855v-4.948h2.854Z",
    transform: "translate(-32.565 -290.306)",
    fill: "#27a2db"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_96",
    "data-name": "Rectangle 96",
    width: 4.279,
    height: 3.726,
    transform: "translate(20.68 29.2)",
    fill: "#2d93ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_258",
    "data-name": "Path 258",
    d: "M168.213,241.91v-3.726h4.279Z",
    transform: "translate(-147.53 -208.984)",
    fill: "#27a2db"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_97",
    "data-name": "Rectangle 97",
    width: 4.279,
    height: 3.726,
    transform: "translate(27.175 29.2)",
    fill: "#2d93ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_259",
    "data-name": "Path 259",
    d: "M221.012,241.91v-3.726h4.279Z",
    transform: "translate(-193.837 -208.984)",
    fill: "#27a2db"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_98",
    "data-name": "Rectangle 98",
    width: 4.279,
    height: 3.726,
    transform: "translate(20.846 24.25)",
    fill: "#2d93ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_260",
    "data-name": "Path 260",
    d: "M169.535,201.636V197.91h4.279Z",
    transform: "translate(-148.689 -173.662)",
    fill: "#27a2db"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_99",
    "data-name": "Rectangle 99",
    width: 4.279,
    height: 3.726,
    transform: "translate(27.338 24.25)",
    fill: "#2d93ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_261",
    "data-name": "Path 261",
    d: "M222.334,201.636V197.91h4.279Z",
    transform: "translate(-194.996 -173.662)",
    fill: "#27a2db"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_100",
    "data-name": "Rectangle 100",
    width: 4.279,
    height: 3.726,
    transform: "translate(20.774 34.428)",
    fill: "#2d93ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_262",
    "data-name": "Path 262",
    d: "M168.953,284.443v-3.726h4.279Z",
    transform: "translate(-148.179 -246.288)",
    fill: "#27a2db"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_101",
    "data-name": "Rectangle 101",
    width: 4.279,
    height: 3.726,
    transform: "translate(27.266 34.428)",
    fill: "#2d93ba"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_263",
    "data-name": "Path 263",
    d: "M221.752,284.443v-3.726h4.279Z",
    transform: "translate(-194.486 -246.288)",
    fill: "#27a2db"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_45",
    "data-name": "Group 45",
    transform: "translate(24.7 40.618)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_102",
    "data-name": "Rectangle 102",
    width: 0.35,
    height: 9.599,
    transform: "translate(1.316)",
    fill: "#3a556a"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_20",
    "data-name": "Ellipse 20",
    cx: 0.466,
    cy: 0.466,
    r: 0.466,
    transform: "translate(0 4.465)",
    fill: "#3a556a"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_21",
    "data-name": "Ellipse 21",
    cx: 0.466,
    cy: 0.466,
    r: 0.466,
    transform: "translate(1.925 4.465)",
    fill: "#3a556a"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_264",
    "data-name": "Path 264",
    d: "M142.2,6.083H118.631L122.119.706h16.6Z",
    transform: "translate(-104.044 -0.706)",
    fill: "#64798a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_46",
    "data-name": "Group 46",
    transform: "translate(0.004 5.377)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_265",
    "data-name": "Path 265",
    d: "M18.752,127.146H3.1L.036,131.832H18.752Z",
    transform: "translate(-0.036 -116.977)",
    fill: "#3a556a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_266",
    "data-name": "Path 266",
    d: "M273.794,127.146h15.651l3.065,4.686H273.794Z",
    transform: "translate(-240.133 -116.977)",
    fill: "#3a556a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_103",
    "data-name": "Rectangle 103",
    width: 1.883,
    height: 14.855,
    transform: "translate(16.831)",
    fill: "#3a556a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_104",
    "data-name": "Rectangle 104",
    width: 1.883,
    height: 14.855,
    transform: "translate(33.66)",
    fill: "#3a556a"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_22",
    "data-name": "Ellipse 22",
    cx: 5.267,
    cy: 5.267,
    r: 5.267,
    transform: "translate(20.926 8.271)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_267",
    "data-name": "Path 267",
    d: "M172.954,76.354a5.618,5.618,0,1,1,5.618-5.618A5.624,5.624,0,0,1,172.954,76.354Zm0-10.532a4.914,4.914,0,1,0,4.914,4.914A4.92,4.92,0,0,0,172.954,65.823Z",
    transform: "translate(-146.761 -57.199)",
    fill: "#fcd462"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_47",
    "data-name": "Group 47",
    transform: "translate(21.795 9.089)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_268",
    "data-name": "Path 268",
    d: "M207.522,74.829h.368v1.012h-.162v-.86h-.205Z",
    transform: "translate(-203.8 -74.804)",
    fill: "#2f4859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_269",
    "data-name": "Path 269",
    d: "M212.722,75.049a.2.2,0,0,0,.044-.12.136.136,0,0,0-.047-.1.165.165,0,0,0-.117-.043.242.242,0,0,0-.207.128l-.138-.08a.5.5,0,0,1,.147-.15.382.382,0,0,1,.207-.051.335.335,0,0,1,.222.08.272.272,0,0,1,.1.219.3.3,0,0,1-.04.149,1.014,1.014,0,0,1-.149.182l-.237.242h.459v.164h-.692v-.145l.307-.308A1.669,1.669,0,0,0,212.722,75.049Z",
    transform: "translate(-207.953 -74.629)",
    fill: "#2f4859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_270",
    "data-name": "Path 270",
    d: "M177.566,107.446a.225.225,0,0,0,.2-.091.431.431,0,0,0,.065-.246.362.362,0,0,1-.1.076.321.321,0,0,1-.151.036.312.312,0,0,1-.228-.091.322.322,0,0,1-.092-.24.313.313,0,0,1,.1-.241.355.355,0,0,1,.25-.091.336.336,0,0,1,.336.217.723.723,0,0,1,.052.281.872.872,0,0,1-.033.261.423.423,0,0,1-.091.165.368.368,0,0,1-.277.119.475.475,0,0,1-.3-.1l.085-.126a.322.322,0,0,0,.089.052A.265.265,0,0,0,177.566,107.446Zm.031-.376a.221.221,0,0,0,.146-.049.156.156,0,0,0,.059-.126.181.181,0,0,0-.056-.133.193.193,0,0,0-.141-.056.2.2,0,0,0-.14.05.165.165,0,0,0-.055.128.186.186,0,0,0,.05.132A.179.179,0,0,0,177.6,107.07Z",
    transform: "translate(-177.255 -102.631)",
    fill: "#2f4859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_271",
    "data-name": "Path 271",
    d: "M210.54,139.14a.225.225,0,0,0-.2.091.429.429,0,0,0-.065.246.361.361,0,0,1,.1-.076.322.322,0,0,1,.151-.036.312.312,0,0,1,.228.09.322.322,0,0,1,.092.24.313.313,0,0,1-.1.241.355.355,0,0,1-.25.091.336.336,0,0,1-.336-.217.724.724,0,0,1-.052-.281.873.873,0,0,1,.033-.261.423.423,0,0,1,.091-.165.367.367,0,0,1,.277-.119.475.475,0,0,1,.3.1l-.086.126a.322.322,0,0,0-.089-.052A.262.262,0,0,0,210.54,139.14Zm-.031.376a.222.222,0,0,0-.146.048.156.156,0,0,0-.059.126.181.181,0,0,0,.057.133.193.193,0,0,0,.142.056.206.206,0,0,0,.142-.05.162.162,0,0,0,.056-.128.182.182,0,0,0-.192-.186Z",
    transform: "translate(-206.074 -131.074)",
    fill: "#2f4859"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_272",
    "data-name": "Path 272",
    d: "M242.988,108.769v-.152h.592v.133l-.245.274a.3.3,0,0,1,.217.088.281.281,0,0,1,.078.2.3.3,0,0,1-.1.243.406.406,0,0,1-.27.088.574.574,0,0,1-.323-.106l.072-.138a.449.449,0,0,0,.261.087.242.242,0,0,0,.145-.041.138.138,0,0,0,.057-.119.146.146,0,0,0-.064-.124.3.3,0,0,0-.177-.046.372.372,0,0,0-.109.016v-.13l.235-.272h-.366Z",
    transform: "translate(-234.857 -104.438)",
    fill: "#2f4859"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_105",
    "data-name": "Rectangle 105",
    width: 0.216,
    height: 2.737,
    transform: "translate(4.435 1.935)",
    fill: "#2f4859"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_106",
    "data-name": "Rectangle 106",
    width: 1.991,
    height: 0.234,
    transform: "translate(2.336 4.558)",
    fill: "#2f4859"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_107",
    "data-name": "Rectangle 107",
    width: 0.136,
    height: 4.681,
    transform: "matrix(-0.751, 0.66, -0.66, -0.751, 28.651, 16.229)",
    fill: "#e56353"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_23",
    "data-name": "Ellipse 23",
    cx: 0.352,
    cy: 0.352,
    r: 0.352,
    transform: "translate(25.979 13.41)",
    fill: "#27a2db"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgE2);
export default __webpack_public_path__ + "static/media/e2.1be62ef33b52fec8a340a02bdb4a1c12.svg";
export { ForwardRef as ReactComponent };